// @flow
import type {SearchRequest} from '../models/SearchRequest';
import type {Root} from '../toURL';
import SearchUrlBuilder from '../models/SearchUrlBuilder';
import {canonicalizeKeywords, encodeURIComponentString} from '../utils';
import {ROOT_PATH} from '../toURL';
import {
    KEYWORDS,
    PAGE,
    ARRIVAL,
    DEPARTURE,
    REGION,
    MIN_NIGHTLY_PRICE,
    MAX_NIGHTLY_PRICE,
    MIN_BEDROOMS,
    MAX_BEDROOMS,
    MIN_BATHROOMS,
    MAX_BATHROOMS,
    MIN_SLEEPS,
    MAX_SLEEPS
} from '../models/SearchUrlParameters';

export default class SearchUrlFormatter {
    root: Root = ROOT_PATH;
    format(searchRequest: SearchRequest, options: any = {}): string {
        let boundingBoxParameters;
        const {
            neLat,
            neLong,
            swLat,
            swLong,
            zoom,
            q,
            page,
            arrival,
            departure,
            regionId,
            minPrice,
            maxPrice,
            minBedrooms,
            maxBedrooms,
            minBathrooms,
            maxBathrooms,
            minSleeps,
            maxSleeps,
            filter,
            ...rest
        } = searchRequest;
        if (neLat && neLong && swLat && swLong && zoom) {
            boundingBoxParameters = {neLat, neLong, swLat, swLong, zoom};
        }

        const keywords = options.canonicalizeKeywords
            ? canonicalizeKeywords(q)
            : q;

        return SearchUrlBuilder.builder()
            .addQueryParameters(rest) // this needs to be called first, order is important
            .addColonParameter(KEYWORDS, encodeURIComponentString(keywords))
            .addColonParameter(PAGE, page)
            .addColonParameter(ARRIVAL, arrival)
            .addColonParameter(DEPARTURE, departure)
            .addColonParameter(REGION, regionId)
            .addFilterPathSegments(filter)
            .addSlashParameter(MIN_NIGHTLY_PRICE, minPrice)
            .addSlashParameter(MAX_NIGHTLY_PRICE, maxPrice)
            .addBedroomParameters(
                MIN_BEDROOMS,
                MAX_BEDROOMS,
                minBedrooms,
                maxBedrooms
            )
            .addSlashParameter(MIN_BATHROOMS, minBathrooms)
            .addSlashParameter(MAX_BATHROOMS, maxBathrooms)
            .addSlashParameter(MIN_SLEEPS, minSleeps)
            .addSlashParameter(MAX_SLEEPS, maxSleeps)
            .addMapBoundingBoxParameters(boundingBoxParameters)
            .build();
    }
}
